import { uploadKycReviewAttachment } from "@/services/kycReview";
import { KycAttachmentMeta } from "@/types/kycReview";
import {
  materializeUploadFile,
  UPLOAD_READ_ERROR_MESSAGE,
} from "@/utils/uploadFiles";

export const INVALID_MULTIPART_UPLOAD_MESSAGE =
  "We couldn't upload your file. Please select it again and retry. If the problem continues, try another browser.";

export const FILE_TOO_LARGE_UPLOAD_MESSAGE =
  "Your file is too large to upload. Please select a smaller file and try again.";

export async function uploadAccountUpdateAttachment({
  image,
  file,
}: {
  image: string;
  file: File;
}) {
  let stableFile: File;
  try {
    stableFile = await materializeUploadFile(file);
  } catch {
    throw new Error(UPLOAD_READ_ERROR_MESSAGE);
  }

  const response = await uploadKycReviewAttachment(image, stableFile);
  const meta = response.data?.data?.image as KycAttachmentMeta | undefined;
  if (!meta) throw new Error("Upload did not return file details.");
  return meta;
}

export function getAttachmentUploadErrorMessage({
  error,
  fallback,
}: {
  error: unknown;
  fallback: string;
}) {
  const failure = error as
    | {
        message?: string;
        response?: { status?: number; data?: { code?: string; message?: string } };
      }
    | undefined;
  const response = failure?.response;

  if (response?.status === 413) {
    return FILE_TOO_LARGE_UPLOAD_MESSAGE;
  }
  if (response?.data?.code === "invalid-multipart") {
    return INVALID_MULTIPART_UPLOAD_MESSAGE;
  }
  if (response && response.status !== undefined && response.status >= 500) {
    return fallback;
  }
  return response?.data?.message || failure?.message || fallback;
}
